function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS AddRemoveButtons INSTEAD.
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from '@unite-us/ui';
import { hideAddButton, hideRemoveButton } from "./utils";

/**
 *
 * @visibleName AddRemoveButtons DEPRECATED
 */
var AddRemoveButtons = /*#__PURE__*/function (_Component) {
  function AddRemoveButtons(props) {
    var _this;
    _classCallCheck(this, AddRemoveButtons);
    _this = _callSuper(this, AddRemoveButtons, [props]);
    _this.onAddClick = _this.onAddClick.bind(_this);
    _this.onRemoveClick = _this.onRemoveClick.bind(_this);
    return _this;
  }
  _inherits(AddRemoveButtons, _Component);
  return _createClass(AddRemoveButtons, [{
    key: "onAddClick",
    value: function onAddClick() {
      this.props.onAddClick(this.props.index);
    }
  }, {
    key: "onRemoveClick",
    value: function onRemoveClick() {
      this.props.onRemoveClick(this.props.index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        iconSize = _this$props.iconSize,
        index = _this$props.index,
        length = _this$props.length,
        customHideRemoveButton = _this$props.customHideRemoveButton;
      return /*#__PURE__*/React.createElement("div", {
        className: classnames('ui-add-remove-buttons', className)
      }, !hideRemoveButton(length, index, customHideRemoveButton) && /*#__PURE__*/React.createElement("div", {
        className: "ui-add-remove-buttons__remove mr-quarter"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.onRemoveClick,
        role: "button",
        tabIndex: 0,
        title: "Remove"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "IconMinusCircle",
        size: iconSize
      }))), !hideAddButton(length, index) && /*#__PURE__*/React.createElement("div", {
        className: "ui-add-remove-buttons__add"
      }, /*#__PURE__*/React.createElement("a", {
        onClick: this.onAddClick,
        role: "button",
        tabIndex: 0,
        title: "Add"
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: "IconPlusCircle",
        size: iconSize
      }))));
    }
  }]);
}(Component);
AddRemoveButtons.propTypes = {
  className: PropTypes.string,
  /** Custom function defaults to undefined */
  customHideRemoveButton: PropTypes.func,
  /** Called when add (+) icon button is clicked. */
  onAddClick: PropTypes.func.isRequired,
  /**
   * Called when remove (-) icon button is clicked.
   * @param {number} indexToRemove the index of item to remove
   */
  onRemoveClick: PropTypes.func.isRequired,
  /** Size in px of icons, defaults to 18px */
  iconSize: PropTypes.number,
  /** Current index in list of items. */
  index: PropTypes.number.isRequired,
  /** Current length of items. */
  length: PropTypes.number.isRequired
};
AddRemoveButtons.defaultProps = {
  className: '',
  customHideRemoveButton: undefined,
  iconSize: 18
};
export default AddRemoveButtons;